import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { Button } from '@opswat/ui';
import { useGTM } from 'hooks/useGTM';
import notFound from 'images/notFound.svg';

export const ServerError = () => {
    const { t } = useTranslation();
    const { trackClick } = useGTM();
    return (
        <div className='tw:flex tw:flex-col tw:justify-center tw:items-center tw:w-full tw:h-full tw-m-auto'>
            <img src={notFound} draggable={false} alt={t('Not found icon')} />
            <div className='tw:flex tw:flex-col tw:gap-32 tw:justify-between'>
                <div className='tw:md:w-580 tw:px-10 tw:flex tw:flex-col tw:gap-9 tw:justify-between tw:text-center'>
                    <span className='tw:text-headline'>{t('Currently Under Maintenance')}</span>
                    <span className='tw:text-body tw:text-neutrals-800 tw:dark:text-neutrals-500'>{t('We appreciate your patience and will restore service as soon as possible.')}</span>
                </div>
                <Link to='https://www.opswat.com' className='tw:m-auto'>
                    <Button variant='primary' className='tw:font-medium tw:px-8' text={t('Back to OPSWAT')}
                        onClick={() => trackClick('error-page-back-to-opswat-button', 'ui', 'Back to OPSWAT button clicked')}
                    />
                </Link>
            </div>
        </div>
    );
};
